module.exports = __webpack_public_path__ + "5308cde2fd22088531e49af593940347.jpg";